import { AuthUser } from 'types/user';

export const getUserId = (user: AuthUser) => user?.sub.replace('auth0|', '');
